import type { Image } from '@sanity/types';
import type { ImageOptions, Options } from '@pkg/ui/composables/useSanityImage';
import { useSanityImage as useSanityImageFromUi } from '@pkg/ui/composables/useSanityImage';

export type { ImageOptions, Options };

export const useSanityImage = (
  image: Image | undefined | null,
  options: Options = {},
  imageOptions: ImageOptions = {},
) => useSanityImageFromUi(image, options, imageOptions);
